<template lang="html">
   <div class="test-form">
      <div class="my-5 row justify-content-md-center" style="margin: 0">
         <div class="col-12 col-md-11 col-lg-10 col-xl-9">
            <Form 
               classBinding="row" 
               :name="Product.forms.add_user.name"
               :ref="Product.forms.add_user.name" 
               :forms="Product.forms.add_user.forms" 
               :formData="Product.forms.add_user.data"
               @button-click="clickButton"
               @file-selected="uploadFile"
            />

            
         </div>
      </div>
   </div>
</template>

<script>
import product from "./resources/stores/product.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('product')
   },
   created(){
      utils.registerModule('product',product,this.$store)
   },
   components:{
      Form: () => import("@/libs/clarks/components/form"),
   },
   computed: {
      ...mapGetters([
         'Product',
         'products'
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
      ]),
      async clickButton(e){
         if(e.name === 'submit'){
            if(await e.ref.isValid()){
               $notify('success','Valid Form', 'Form is valid',20)
            }
         }
      },
      uploadFile(e){
         console.log('Name',e)
      }
   },
   mounted(){
      utils.registerModule('product',product,this.$store)
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>